import AbstractEntity from "../AbstractEntity";

export default class Intervention extends AbstractEntity {
    static STATUS_IN_PROGRESS = 0;
    static STATUS_SUCCESS = 1;
    static STATUS_FAILED = 2;
    static STATUS_FORCED_SUCCESS = 3;

    _id;
    _token;
    _artisanPrice;
    _clientPrice;
    _status;
    _artisanId;
    _companyId;
    _appointment;
    _secondAppointment;
    _companyComment;
    _livePayment;
    _clientInvoiceId;
    _suggestionId;
    _createdAt;
    _successAt;
    _failedAt;
    _successForcedAt;
    _orderId;
    _quotationId;
    _qualityInspectionId;
    _interventionDocumentId;
    _requestedDocumentsId;
    _interventionItemsId;
    _penaltyItemsId;


    getId() {
        return this._id;
    }

    getToken() {
        return this._token;
    }

    getArtisanPrice() {
        return this._artisanPrice;
    }

    getClientPrice() {
        return this._clientPrice;
    }

    getStatus() {
        return this._status;
    }

    getArtisanId() {
        return this._artisanId;
    }

    getCompanyId() {
        return this._companyId;
    }

    getAppointment() {
        return this._appointment;
    }

    getSecondAppointment() {
        return this._secondAppointment;
    }

    getCompanyComment() {
        return this._companyComment;
    }

    isLivePayment() {
        return this._livePayment;
    }

    getClientInvoiceId() {
        return this._clientInvoiceId;
    }

    getSuggestionId() {
        return this._suggestionId;
    }

    getCreatedAt() {
        return this._createdAt;
    }

    getSuccessAt() {
        return this._successAt;
    }

    getFailedAt() {
        return this._failedAt;
    }

    getSuccessForcedAt() {
        return this._successForcedAt;
    }

    getOrderId() {
        return this._orderId;
    }

    getQuotationId() {
        return this._quotationId;
    }

    getQualityInspectionId() {
        return this._qualityInspectionId;
    }

    getInterventionDocumentId() {
        return this._interventionDocumentId;
    }

    getRequestedDocumentsId() {
        return this._requestedDocumentsId;
    }

    getInterventionItemsId() {
        return this._interventionItemsId;
    }

    getPenaltyItemsId() {
        return this._penaltyItemsId;
    }

    getClassName() {
        return "intervention";
    }
}